export default __webpack_public_path__ + "static/media/pennybun2.a3a678c0.png";